<div class="container mt-4">

  <h2>Pagar pelo
    <img src="/images/google-pay-logo.svg" alt="Google Pay" class="google-pay-logo " *ngIf="pagarComGooglePay()"
         style="height: 55px;  ">

    <i class="fab fa-apple-pay fa-2x ml-2 mr-2" *ngIf="pagarComApplePay()"></i>

  </h2>

  <div *ngIf="!carregouDados" class="text-center">
     <i class="k-icon k-i-loading mr-1"></i> carregando...
  </div>

  <span [hidden]="!carregouDados">
      <div class="valor">{{dados.valorPagamento | currency: "BRL"}}</div>

      <div class="botoes">
        <!-- Google Pay -->
        <div id="google-pay-container" style="margin: 20px 0;"  [hidden]="!pagarComGooglePay()"> </div>

        <div id="applePayDiv" [hidden]="!pagarComApplePay()" class="mt-3"></div>
      </div>

      <div id="loading" style="display: none;" class="loading">
        <div class="spinner"></div>
        <p>Processando pagamento...</p>
      </div>

  </span>

  <div class="col-12" *ngIf="msgErro">
    <div class="alert alert-danger mt-2">
      {{msgErro}}
    </div>
  </div>
</div>


